import React, { useEffect, useState } from 'react';
import "../../assets/css/ganttchart.css";

// Esse gráfico de Gantt deve receber como parâmetro rows um array do que deve ser observado nas linhas do gráfico.
// esse array deve conter o dado "diaRow" que é o dia que deve ser destacado na linha. (o match entre a linha e a coluna do gráfico)

const GanttChart = ( { setRows, rows, datesObj, days } ) => {

  const [draggedData, setDraggedData] = useState(null); // Data for the draggable div
  const [dropMessage, setDropMessage] = useState(null);

  // Handle drag start
  const handleDragStart = (e, row) => {
    const data = JSON.stringify(row);
    e.dataTransfer.setData('object', data); // Pass data to the drop target
    console.log(JSON.parse(e.dataTransfer.getData('object')))
    e.target.style.opacity = '0.5'; // Optional visual feedback
  };

  // Handle drag end
  const handleDragEnd = (e) => {
    e.target.style.opacity = '1';
  };

  // Allow drop
  const handleDragOver = (e) => {
    e.preventDefault(); // Necessary to allow drop
  };

  //Reset Opacity
  const resetOpacity = (e) => {
    if (e.target.style.opacity = '0.5') {
      e.target.style.opacity = '1';
    }
  }

  // Handle drop
  const handleDrop = (e, dropZoneData) => {
    resetOpacity(e);
    e.preventDefault();
    const data = JSON.parse(e.dataTransfer.getData('object'));
    setDropMessage(data);
    setDraggedData(dropZoneData); // Update the draggable div's data
    const updatedArray = rows.map(row =>
      row.prod_id === dropZoneData.prod_id
        ? { ...row, diaRow: dropZoneData.diaRow, prod_dtInterna: dropZoneData.prod_dtInterna } // Update the object with id: 2
        : row // Keep other objects unchanged
    );
    setRows(updatedArray);
  };

  const getDayWeek = (day) => {
    const days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
    return days[day];
  }

  return (
    <div className="grid-container">
      {/* Grid Header: Days */}
      <div className="grid-header">
        <div className="grid-cell"></div> {/* Empty corner cell */}
        <div className="grid-cell header">
          {Object.keys(datesObj) && Object.keys(datesObj).map((month, monthIndex) => (
            <div key={monthIndex} className="grid-cell header">
              {datesObj[month].map((day, dayIndex) => (
                <div key={dayIndex} className="grid-cell header">
                  {day}<br/>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="grid-rows">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="grid-row">
            <div className="grid-cell row-header">{row.prod_desc}</div>
            {
              Object.keys(datesObj) && Object.keys(datesObj).map((month, monthIndex) => (
                <div key={monthIndex} className="">
                  {datesObj[month].map((day, dayIndex) => (
                    <div key={dayIndex} className="grid-cell">
                      {day}<br/>
                    </div>
                  ))}
                </div>
              ))
              /*
              days.map((day) => {
                if (day === row.prod_dtInterna) {
                  return (
                    <div
                      key={day.day}
                      className="grid-cell"
                      style={{backgroundColor: 'lightgreen', cursor: 'grab'}}
                      onDragStart={(e) => handleDragStart(e, row)}
                      onDragEnd={handleDragEnd}
                      onDrop={(e) => handleDrop(e, {...row, diaRow: day.day, prod_dtInterna: `${year}-${months[0] <= 9 ? `0${months[0]}` : `${months[0]}`}-${day.day <= 9 ? `0${day.day}` : `${day.day}`}`})}
                      draggable
                      >
                    </div>
                  )
                } else {
                  return (
                    <div key={day.day} className="grid-cell"
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, {...row, diaRow: day.day, prod_dtInterna: `${year}-${months[0] <= 9 ? `0${months[0]}` : `${months[0]}`}-${day.day <= 9 ? `0${day.day}` : `${day.day}`}`})}
                    >
                    </div>
                  )
                }
              }
             )
              */
            }
          </div>
        ))}
      </div>
    </div>
  )
}

export default GanttChart;
